<template>
  <div
    class="bottom-slide-progress-bar"
    id="bottom-progress-bar"
  >
    <div
      class="slide-progress-bar"
      :style="{backgroundColor: $store.state.slide.textColour, width: percentProgress}"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      slides: [],
      percentProgress: `${0}%`,
    }
  },
  watch: {
    '$store.state.slide.id': function () {
      this.getDataProgress()
    },
  },
  mounted() {
    this.getSlideList()
  },

  methods: {
    ...mapActions(['getSlidesAction']),
    getDataProgress() {
      if (!this.$store.state.slide.id && !this.slides.length) return
      const index = this.slides.findIndex((item) => {
        return item.id == this.$store.state.slide.id
      })
      if (index != -1) {
        this.percentProgress = `${(index + 1) / this.slides.length * 100}%`
      }
    },

    async getSlideList() {
      this.slides = await this.getSlidesAction()

      this.slides.sort((a, b) => {
        return a.order - b.order
      })

      this.getDataProgress()
    },
  },
}

</script>

<style lang="scss" scoped>
.bottom-slide-progress-bar {
  height: 2px;
  width: 100%;
  .slide-progress-bar {
    height: 100%;
    transition: width 0.5s;
  }
}
</style>
